(function() {

    var siteNav = '#js-site-nav';
    var $siteNav = $(siteNav);

    var banner = '#js-banner';
    var $banner = $(banner);

    var logoBar = '#js-logo-bar';
    var $logoBar = $(logoBar);

    var dummyLogoBar = '#js-dummy-logo-bar';
    var $dummyLogoBar = $('<div class="js-dummy" id="js-dummy-logo-bar"></div>');

    var params = {
        navBreakpoint: _breakpoints.m,
        attachedClass: 'is-fixed',
        transitionningClass: 'is-transitionning',
        scrollThreshold: 34,
        minScrollUp: 20,
        minScrollDown: 50,
        viewportHeightThreshold: 768,
        bannerHeight: 0
    };

    //	======================================================================  //
    //	Functions
    //	======================================================================  //

    /**
     * @function `resizeDummyLogoBar`
     *
     * Matches the height of the dummy logo bar to the height of the original one.
     *
     * 1. Bring it up if the header has padding at its top.
     */
    function resizeDummyLogoBar() {
        $dummyLogoBar.css({
            height: $logoBar.outerHeight(),
            // marginTop: '-' + _$siteHeader.css('padding-top') /* [1] */
        });
    }

    /**
     * @function `attachLogoBar`
     *
     * Attaches the logo bar at the top of the viewport.
     *
     * 1. Quick escape if the width of the screen is greater than the maximum
     *    width accepted for that behavior.
     * 2. Never run that function more than once.
     * 3. Create a dummy copy of that logo bar to be inserted right after it so
     *    that it pushes the content to the same Y-position once the original logo
     *    bar gets attached (out of the flow).
     */
    function attachLogoBar() {
        if( _window_width > params.navBreakpoint ) { /* [1] */
            return;
        }
        if( $logoBar.hasClass(params.attachedClass) ) { /* [2] */
            return;
        }
        if( _scroll_position < params.scrollThreshold ) {
            return;
        }
        resizeDummyLogoBar();
        $logoBar.addClass(params.attachedClass);
        if( _$document.find(dummyLogoBar).length ) {
            return;
        }
        $dummyLogoBar.insertAfter( $logoBar ); /* [3] */
    }

    /**
     * @function `detachLogoBar`
     *
     * Detaches the logo bar from the top of the viewport.
     *
     * 1. Quick escape if the width of the screen is greater than the maximum
     *    width accepted for that behavior.
     * 2. Never run that function more than once.
     */
    function detachLogoBar() {
        if( _window_width > params.navBreakpoint ) { /* [1] */
            return;
        }
        if( !$logoBar.hasClass(params.attachedClass) ) { /* [2] */
            return;
        }
        if( _scroll_position >= params.scrollThreshold ) {
            return;
        }
        $dummyLogoBar.css('height', '0px');
        $logoBar.removeClass(params.attachedClass);
    }

    /**
     * @function `updateScrollThreshold`
     *
     * Sets the good scroll threshold depending on the height of the viewport.
     */
    function updateScrollThreshold() {
        if( _window_height >= params.viewportHeightThreshold ) {
            params.scrollThreshold = 34 + params.bannerHeight;
        }
        else {
            params.scrollThreshold = 15 + params.bannerHeight;
        }
    }

    /**
     * @function `detachNav`
     *
     * Detaches the navigation so that it gets back in the flow of the content
     * (= pushes the content underneath it).
     */
    function detachNav() {
        $siteNav.removeClass(params.attachedClass);
    }

    /**
     * @function `navOnScroll`
     *
     * Manages the behavior of the header navigation as the user scrolls.
     *
     * 1. When at the top of the page, detach the nav.
     * 2. Quick escape: don't do anything below the minimum scroll distance.
     * 3. When scrolling up (below the minimum scroll distance), require a minimum
     *    scroll distance to trigger any changes.
     * 4. ...if the nav is already attached, don't do anything.
     * 5. ...otherwise, it's ok to slide the nav in. To do so: attach it and
     *     quickly bring it up (by adding the "transitionning" class)
     * 6. ...and let it slide down.
     * 7. When scrolling down (again: below the minimum scroll distance), require
     *    a minimum scroll distance to trigger any changes.
     * 8. If the nav is not attached or has been detached, don't do anything.
     */
    function navOnScroll() {
        var attached_nav = $siteNav.hasClass(params.attachedClass) ? true : false;
        // if( _scroll_position === 0 ) { /* [1] */
        // 	detachNav();
        // }
        if( _scroll_position < params.scrollThreshold ) { /* [2] */
            detachLogoBar();
            return;
        }
        else {
            attachLogoBar();
        }
        // if( !_scrollingDown() ) {
        //     if( _started_scroll_at - _scroll_position <
        //         params.minScrollUp ) { /* [3] */
        //         return;
        //     }
        //     if( attached_nav ) { /* [4] */
        //         return;
        //     }
        //     $siteNav.addClass(params.attachedClass+' '+
        //         params.transitionningClass); /* [5] */
        //     setTimeout(function() { /* [6] */
        //         $siteNav.removeClass(params.transitionningClass);
        //     }, 10);
        // }
        // else {
        //     if( _scroll_position - _started_scroll_at <
        //         params.minScrollDown ) { /* [7] */
        //         return;
        //     }
        //     if( !attached_nav ) { /* [8] */
        //         return;
        //     }
        //     detachNav();
        // }
    }

    function setBannerOffset() {
        if ($banner[0] && _window_width > params.navBreakpoint) {
            params.bannerHeight = $banner[0].clientHeight;
            var offsetTop = $banner[0].getBoundingClientRect().top + params.bannerHeight;
            if (offsetTop < 0) {
                document.documentElement.style.setProperty('--banner-offset', 0);
            } else {
                document.documentElement.style.setProperty('--banner-offset', offsetTop + 'px');
            }
        } else {
            document.documentElement.style.setProperty('--banner-offset', params.bannerHeight + 'px');
        }
    }

    //	======================================================================  //
    //	On ready
    //	======================================================================  //

    onReady.callbacks.header = function() {
        updateScrollThreshold();
        attachLogoBar();
    };

    //	======================================================================  //
    //	On scroll
    //	======================================================================  //

    onScroll.callbacks.header = function() {
        navOnScroll();
    };

    window.addEventListener('scroll', setBannerOffset);

    window.addEventListener('resize', setBannerOffset);

    //	======================================================================  //
    //	On resize
    //	======================================================================  //

    onResize.callbacks.header = function() {
        updateScrollThreshold();
        attachLogoBar();
        if( _window_width > params.navBreakpoint ) {
            resizeDummyLogoBar();
        }
    };

})();
